import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import useScreenSize from '../hooks/useScreenSize';

const Card = React.forwardRef(({ children, className = '', noPadding = false, style }, ref) => {
  const { isMobile } = useScreenSize();

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={clsx(
        'bg-white rounded-xl shadow-sm border border-gray-100',
        !noPadding && (isMobile ? 'p-4' : 'p-6'),
        !isMobile && 'hover:shadow-md transition-shadow duration-300',
        className
      )}
      style={style}
    >
      {children}
    </motion.div>
  );
});

export default Card;


